export default "__VITE_ASSET__gkAVFLJi__"